module.exports = __webpack_public_path__ + "img/food6.ba344b2a.jpg";